<template>
  <img :src="iconSrc" :title="type | integrationType">
</template>

<script>
  import { SMARTSUPP_INTEGRATION } from '@/utils/integration.constants'

  export default {
    props: {
      type: {
        type: String,
        required: true,
        default: ''
      }
    },

    computed: {
      iconSrc() {
        if (this.type === SMARTSUPP_INTEGRATION.type) return SMARTSUPP_INTEGRATION.icon

        return null
      }
    }
  }
</script>
